import React, { forwardRef, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import { LeftArrowIcon, RightArrowIcon } from 'components'
import { splitTextInTwo } from 'helpers/strings'
import { useBreakpoints } from 'hooks'

const NavButton = forwardRef((props, ref) => (
  <button
    type="button"
    className="w-4 h-4 flex justify-between items-center bg-transparent text-white outline-none rounded-full focus:ring disabled:opacity-40"
    {...props}
    ref={ref}
  />
))

const SwiperWithTitle = ({ title, className, disableSwipe, ...rest }) => {
  const { lg } = useBreakpoints()
  const prevRef = useRef(null)
  const nextRef = useRef(null)
  const splitTitle = splitTextInTwo(title)

  return (
    <div
      className={classnames('border-0 border-t-2 border-solid border-white pt-4', className)}
      style={{ borderColor: '#D8D8D8' }}
    >
      <div className="flex justify-between items-center">
        <h6 className="text-white">
          {splitTitle.map((text, index) => (
            <span key={index} className={classnames({ 'text-gray-500': index === 1 })}>
              {text}
            </span>
          ))}
        </h6>
        <div className="w-11 flex mt-0 justify-between">
          <NavButton ref={prevRef}>
            <LeftArrowIcon className="w-full" />
          </NavButton>
          <NavButton ref={nextRef}>
            <RightArrowIcon className="w-full" />
          </NavButton>
        </div>
      </div>
      <Swiper
        className="items-stretch mt-6"
        onInit={swiper => {
          swiper.params.navigation.prevEl = prevRef.current
          swiper.params.navigation.nextEl = nextRef.current
          swiper.navigation.update()
        }}
        spaceBetween={lg ? 30 : 15}
        slidesPerView="auto"
        watchSlidesVisibility
        threshold={10}
        allowSlideNext={!disableSwipe}
        allowSlidePrev={!disableSwipe}
        {...rest}
      />
    </div>
  )
}

SwiperWithTitle.propTypes = {
  title: PropTypes.string.isRequired,
  disableSwipe: PropTypes.bool,
}

export { SwiperWithTitle, SwiperSlide }
